import { makeAutoObservable } from 'mobx'
import { AppThemeName, getAppTheme_LS, setAppTheme_LS } from 'src/localStorage/app-theme'
import { PATH_LETTER_HAMMER, ROUTE_WORKOUT } from 'src/resources/routes'

const MiniLayoutPaths = [`${ROUTE_WORKOUT}/${PATH_LETTER_HAMMER}`]

class UIStore {
  isMiniLayout = false
  isPadding = true
  appTheme: AppThemeName = getAppTheme_LS() ?? 'classic'

  constructor() {
    makeAutoObservable(this)
    if (MiniLayoutPaths.includes(window.location.pathname))
      this.isMiniLayout = true
  }

  setMinimizeLayout(isMinimized: boolean) {
    this.isMiniLayout = isMinimized
  }

  setAppTheme(theme: AppThemeName) {
    this.appTheme = theme
    setAppTheme_LS(theme)
  }

  toggleAppTheme() {
    this.setAppTheme(this.appTheme === 'classic' ? 'journal' : 'classic')
  }
}

export default new UIStore()
